import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const SemiModal = ({
    children,
    onOverlayClick,
    className = "",
    isRevamped = false,
    isPrompt = false,
    isFullscreen = false
}) => {
    const styleMap = {
        "cfClose": "styles.cfCLosePrompt",
        "leftFix": "styles.leftFix",
        "phoneExp1": "styles.phoneExp1"
    };
    return (
        <React.Fragment>
            <div onClick={onOverlayClick} styleName={`${isRevamped ? "styles.revampedOverlay" : "styles.overlay"} ${isPrompt ? "styles.promptOverlay" : ""} ${isFullscreen ? "styles.fullscreen" : ""}`} />
            <div styleName={`${className ? styleMap[className] : ``} styles.semiModal`}>
                {children}
            </div>
        </React.Fragment>
    );
};
SemiModal.propTypes = {
    children: PropTypes.object,
    onOverlayClick: PropTypes.func,
    className: PropTypes.string,
    isRevamped: PropTypes.bool,
    isPrompt: PropTypes.bool,
    isFullscreen: PropTypes.bool
};
export default SemiModal;
